import axios from "axios";
import { geoCodeAddress } from "../SignupQuiz/geoCoding";
import { getAuth, createUserWithEmailAndPassword, updateProfile, sendPasswordResetEmail, fetchSignInMethodsForEmail } from "firebase/auth";

export const verifyCompany = async (companyName, websiteLink, address) => {
  const API_KEY = import.meta.env.VITE_PDL_API_KEY; // Replace with your PDL API Key
  const url = `https://api.peopledatalabs.com/v5/company/enrich`;
  //console.table({companyName, websiteLink, address})
  try {
    const response = await axios.get(url, {
      params: {
        name: companyName || undefined, // Include if entered
        website: websiteLink || undefined, // Include if entered
        location: address || undefined, // Include if entered
      },
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": API_KEY,
      },
    });

    return response.data;
  } catch (err) {
    throw new Error("Error verifying company. Please try again.");
  }
};

const checkEmailExists = async (email) => {
  const auth = getAuth();
  try {
    const signInMethods = await fetchSignInMethodsForEmail(auth, email);
    return signInMethods.length > 0;
  } catch (error) {
    console.error("Error checking email:", error);
    throw error;
  }
};

export const createCompany = async (req, res) => {
  const auth = getAuth();

  try {
    // Check if email already exists in Firebase
    const emailExists = await checkEmailExists(req.contact.email);
    if (emailExists) {
      throw new Error("This email is already registered. Please use a different email address.");
    }

    // Create company in the API first
    const API_KEY = import.meta.env.VITE_API_KEY;
    const url = `https://us-central1-iflo-pro-panel.cloudfunctions.net/api/createCompany`;


    
    
    // Get country code from geocoding
    const countryCode = await geoCodeAddress(req.location.shippingAddress.address1);
    
    const companyData = {
      name: req.name,
      externalId: req.externalId,
      companyMetafields: [
        {
          namespace: "custom",
          key: "wholesaler_choice",
          type: "single_line_text_field",
          value: req.metafields?.wholesaler || "None",
        },
        {
          namespace: "custom",
          key: "truck_count",
          type: "single_line_text_field",
          value: req.metafields?.trucks || "0",
        },
      ],
      location: {
        name: req.location.name,
        shippingAddress: {
          firstName: req.location.shippingAddress.firstName,
          lastName: req.location.shippingAddress.lastName,
          address1: req.location.shippingAddress.address1,
          city: req.location.shippingAddress.city,
          zoneCode: req.location.shippingAddress.province,
          zip: req.location.shippingAddress.zip,
          country: countryCode.countryCode
        },
        taxRegistrationId: req.location.taxRegistrationId
      },
      contact: {
        email: req.contact.email,
        firstName: req.contact.firstName,
        lastName: req.contact.lastName
      },
    };

    ///console.log('Sending company data:', JSON.stringify(companyData, null, 2));

    const response = await axios({
      method: 'POST',
      url,
      data: companyData,
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": API_KEY,
      },
    });

    if (!response.data || response.status !== 201) {
      throw new Error('Failed to create company in API');
    }

    // If company creation was successful, create Firebase user
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      req.contact.email,
      Math.random().toString(36).slice(2) // Generate random password
    );

    // Update user profile with name
    await updateProfile(userCredential.user, {
      displayName: `${req.contact.firstName} ${req.contact.lastName}`
    });

    // Send password reset email so user can set their own password
    await sendPasswordResetEmail(auth, req.contact.email);

    return {
      user: userCredential.user,
      company: response.data
    };

  } catch (error) {
    /*console.error("Error creating company:", error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : error.message);*/
    
    if (error.response?.status === 400) {

      throw new Error(error.response.data.errors[0].message);
    }
    
    throw error;
  }
}

export default { verifyCompany, createCompany };

